<template>
  <div class="next-lots">
    <Heading
      font-size="48px"
      line-height="72px"
      letter-spacing="-0.015em"
      font-color="#000000"
      class="next-lots__title"
    >
      Próximos Lotes:
    </Heading>
    <ul class="next-lots-list">
      <li
        v-for="(item, i) in items"
        :key="i"
        class="next-lots-list__item"
        @click="gotoLote(i)"
      >
        <v-img :src="item" />
      </li>
    </ul>
  </div>
</template>

<script>
import Heading from '@/components/Heading/Heading.vue';

export default {
  name: 'NextLots',
  components: { Heading },
  data() {
    return {
      items: [
        require('../../../assets/next-loot-1.png'),
        require('../../../assets/next-loot-2.png'),
        require('../../../assets/next-loot-3.png'),
        require('../../../assets/next-loot-4.png'),
        require('../../../assets/next-loot-5.png'),
        require('../../../assets/next-loot-1.png'),
        require('../../../assets/next-loot-2.png'),
        require('../../../assets/next-loot-3.png'),
        require('../../../assets/next-loot-4.png'),
        require('../../../assets/next-loot-5.png'),
      ],
    };
  },
  methods: {
    gotoLote(n) {
      this.$router.push({
        name: this.$consts.ROUTES.LEILAO_LOTE.NAME,
        params: {
          leilao: this.$route.params.leilao,
          lote: n,
        },
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/static/css/Variables.scss';
.next-lots {
  padding: 45px 40px;
  background-color: #f5f5f5;
  &__title {
    margin-left: 50px;
    @media (max-width: $lg) {
      margin-left: 0;
      font-size: 26px !important;
      line-height: 30px !important;
    }
  }

  &-list {
    display: flex;
    align-items: center;
    list-style: none;
    max-width: 1680px;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 0 !important;
    height: 500px;

    &__item {
      min-width: 300px;
      height: 400px;
      background-color: #ffffff;

      .v-image__image {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .v-image {
        overflow: initial !important;
        height: 100%;
      }
      & + li {
        margin-left: 40px;
      }

      .v-image__image {
        width: 240px;
        height: 360px;
      }
    }
  }
}
</style>
